<script lang="ts" setup>
defineProps<{ opened: boolean }>()

const { t } = useI18n()

const emit =
  defineEmits<{
    (e: "onOpen"): void
    (e: "onClose"): void
    (e: "onToggle"): void
    (e: "onDelete"): void
    (e: "onApply"): void
  }>()

const { event, sendEvent } = useGAEvent(
  `track_select_content_available_`,
  "custom_event"
)

const algoliaReset = useAlgoliaReset()
const { scopedId } = useAlgoliaWidgetScope()
const allCurrentRefinements = useAisCurrentRefinements({}, scopedId("all"))
const getTotalCurrentRefinements = () => {
  const maybeItems = (allCurrentRefinements as any)?.items
  const items = Array.isArray(maybeItems)
    ? maybeItems
    : Array.isArray(maybeItems?.value)
    ? maybeItems.value
    : []
  return items.reduce(
    (acc: number, current: any) => acc + (current?.refinements?.length ?? 0),
    0
  )
}

const onClickedFilter = (item: string, category: string) => {
  if (item) {
    event.value = {
      event: "select_content",
      action: "filter",
      category: category.toLowerCase(),
      label: t(`filters.utils.availability.${item}`)
    }

    sendEvent({ clearEcommerce: false })
  }
}

const facetNames = ["inStock", "deductibleProduct"]

const { getFilterOptionResultCount } = useSwiftSearchHelper()
</script>

<template>
  <FiltersUtilsDropdown
    content-class="w-[24.5rem] p-4"
    :text="t('filters.utils.common.availability')"
    :opened="opened"
    @onOpen="emit('onOpen')"
    @onClose="emit('onClose')"
    @onToggle="emit('onToggle')"
    @onDelete="emit('onDelete')"
    @onApply="emit('onApply')"
    :facet-name="facetNames"
    id-facet="availability"
  >
    <div
      v-for="(item, index) in facetNames"
      :key="`refinmenet-toggle-${index}`"
      class="space-y-1"
    >
      <AisToggleRefinement
        :attribute="facetNames[index]"
        :label="t(`filters.utils.availability.${item}`)"
      >
        <template v-slot="{ canRefine, refine, value }">
          <FiltersUtilsOption
            :name="item"
            :checked="value.isRefined"
            :disabled="!canRefine"
            @clicked="
              ($event: unknown) => {
                onClickedFilter(item, t('filters.utils.common.availability'))
                if (value.isRefined && getTotalCurrentRefinements() === 1) {
                  algoliaReset?.()
                }
                refine(value)
              }
            "
            :text="t(`filters.utils.availability.${item}`)"
            :n-results="
              getFilterOptionResultCount(
                canRefine,
                value.isRefined,
                value.count
              )
            "
            type="toggle"
          />
        </template>
      </AisToggleRefinement>
    </div>
  </FiltersUtilsDropdown>
</template>

<style lang="scss" scoped>

.scrollbar {
  --scrollbar-color: #b2b2b2;
  --scrollbar-width: 0.4375rem;

  scrollbar-color: var(--scrollbar-color) white;
  scrollbar-width: var(--scrollbar-width);

  &::-webkit-scrollbar {
    @apply w-[var(--scrollbar-width)];
  }

  &::-webkit-scrollbar-thumb {
    @apply rounded-full bg-[var(--scrollbar-color)];
  }
}

</style>
